import React, { useEffect, useState } from "react";
import {
  Dialog,
  Grid,
  Button,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import moment from "moment";
import Notify from "../../Notify";
import { armarMailFinalizacion } from "./funciones";
import UpdatedUploadFiles from "../../../services/UpdatedUploadFiles";
import { getData, postData, putData } from "../../../services/library";
import { enviarmails, logEventos } from "../../../services/services";

export default function FinalizarReclamo(props) {
  const { datos = {}, open, setOpen, actualizar, tabla } = props;

  const [disbtn, setdisbtn] = useState(false);
  const [tanques, setTanques] = useState([]); // tanques asociados al reclamo.
  const [formDetalles, setformDetalles] = useState({
    detalles_finalizado_admin: "",
  });
  let id_reclamo = datos.id_reclamo || datos.idreclamo;
  const [openCloseAdj, setOpenCloseAdj] = useState(false);
  const [mailsReclamos, setmailsReclamos] = useState([]);
  const [tanquesContratos, setTanquesContratos] = useState([]);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  /* -------------------- Fetchers -------------------- */
  const getmails = () => {
    getData("/reclamos_config", setmailsReclamos);
  };

  const getTanquesReclamos = () => {
    const uuidTanques = datos.uuid_tanques || null;
    const uuid = datos.uuid || null;
    if (!uuidTanques && !uuid) return;
    getData(`/reclamos/a/detalleTanques2/${uuidTanques}/${uuid}`, (resp) => {
      if (resp && Array.isArray(resp)) setTanques(resp);
      else setTanques([]);
    });
  };

  const getTanquesContratos = () => {
    if (!tanques || !Array.isArray(tanques) || tanques.length === 0) return;

    setTanquesContratos([]);

    tanques.forEach((t) => {
      getData(`/tanques_contratos/tanque/${t.id_tanque}`, (resp) => {
        if (resp && resp.length > 0) {
          setTanquesContratos((prev) => {
            const nuevos = resp.filter((r) => !prev.some((p) => p.id === r.id));
            return [...prev, ...nuevos];
          });
        } else {
          getData(
            `/tanques_contratos/nro_tanque/${t.nro_tanque}`,
            (respUUID) => {
              if (respUUID && respUUID.length > 0) {
                setTanquesContratos((prev) => {
                  const nuevos = respUUID.filter(
                    (r) => !prev.some((p) => p.id === r.id),
                  );
                  return [...prev, ...nuevos];
                });
              }
            },
          );
        }
      });
    });
  };

  useEffect(() => {
    getmails();
    getTanquesReclamos();
  }, [datos.uuid, datos.uuid_tanques]);

  useEffect(() => {
    getTanquesContratos();
  }, [tanques]);

  /* -------------------- Acciones sobre tanques_contratos -------------------- */
  const handleGuardarTanquesContratos = (e, tanquesAlta) => {
    if (!tanquesAlta || tanquesAlta.length === 0) return;

    const tqs_contratos = tanquesAlta.map((tanque) => ({
      id_tanque: tanque.id_tanque,
      id_direccionentrega:
        datos.direccion_entrega || datos.id_domicilio_ampliacion || null,
      baja: 0,
      usuario: localStorage.getItem("user"),
    }));

    postData(
      e,
      "/tanques_contratos/postandupdate",
      { tqs_contratos, movimientos_tanques: [] },
      setNotificacion,
    );
  };

  const handleBajaTanquesContratos = (e, contratosBaja) => {
    console.log("contratosBaja", contratosBaja);

    if (!contratosBaja || contratosBaja.length === 0) return;

    contratosBaja.forEach((c) => {
      logEventos(
        `Baja de contrato del tanque ${c.id_tanque}`,
        "Reclamos Granel",
        `Se dio de baja por reclamo ${id_reclamo}`,
        localStorage.getItem("user"),
      );
      console.log("c", c);

      putData(e, `/tanques_contratos/${c.id}`, { baja: 1 }, setNotificacion);
    });
  };

  /* -------------------- Guardar reclamo y enviar mails -------------------- */

  const handleGuardarReclamo = async (e) => {
    logEventos(
      `Guardar finalización del reclamo nro ${id_reclamo}`,
      "Reclamos Granel",
      "Se guardo finalización del reclamo",
      localStorage.getItem("user"),
    );

    // 1) Actualiza el reclamo: estado, observaciones del admin y datos del cliente/motivo.
    // La fecha de finalización NO se incluye acá porque el endpoint /update
    // tiene un UPDATE fijo que no la contempla — se guarda en el paso 2.
    const armoBody = {
      estado: 171,
      detalles_finalizado_admin:
        formDetalles.detalles_finalizado_admin !== ""
          ? formDetalles.detalles_finalizado_admin
          : null,
      id_cliente: datos.id_cliente,
      direccion_entrega: datos.direccion_entrega,
      id_motivo: datos.id_motivo,
    };

    await putData(
      e,
      `/reclamos/update/${id_reclamo}`,
      { armoBody },
      setNotificacion,
    );

    // 2) Guarda la fecha de finalización por separado usando /update_2,
    // que hace un SET dinámico (SET ?) y solo toca los campos que recibe.
    // La condición evita pisar una fecha que ya fue guardada anteriormente.
    if (!datos.fecha_finalizado) {
      await putData(
        e,
        `/reclamos/update_2/${id_reclamo}`,
        { fecha_finalizado: moment().format("YYYY-MM-DD HH:mm:ss") },
        setNotificacion,
      );
    }

    // 3) Envio de mails de notificación a los usuarios configurados en reclamos_config.
    if (mailsReclamos && mailsReclamos.length > 0 && datos) {
      const { asunto, html } = armarMailFinalizacion(datos);
      mailsReclamos.forEach((usuario) => {
        if (usuario.email_usuario) {
          enviarmails(usuario.email_usuario, asunto, html);
        }
      });
    }
  };

  /* -------------------- Submit principal -------------------- */

  const handleSubmit = (e) => {
    try {
      handleGuardarReclamo(e);

      const tanquesAlta = (tanques || []).filter((t) => t.instalacion === 1);
      const tanquesBaja = (tanques || []).filter((t) => t.instalacion === 0);

      const contratosBaja = (tanquesContratos || []).filter((tc) =>
        tanquesBaja.some((tb) => tb.id_tanque === tc.id_tanque),
      );

      if (datos.id_motivo === 19) {
        // INSTALACIÓN
        handleGuardarTanquesContratos(e, tanquesAlta);
      } else if (datos.id_motivo === 20) {
        // DESCONEXIÓN
        handleBajaTanquesContratos(e, contratosBaja);
      } else if (datos.id_motivo === 41) {
        // REEMPLAZO
        handleBajaTanquesContratos(e, contratosBaja);
        handleGuardarTanquesContratos(e, tanquesAlta);
      }
    } catch (error) {
      alert("Hubo un error", error);
    }
  };

  /* -------------------- Efectos auxiliares -------------------- */

  useEffect(() => {
    setdisbtn(!(datos && datos.total_archivos > 0));
  }, [datos?.total_archivos]);

  useEffect(() => {
    if (openCloseAdj === false) {
      actualizar();
    }
  }, [openCloseAdj]);

  const handleCloseAdj = () => {
    actualizar && actualizar();
    setOpenCloseAdj(false);
  };

  const handleClose = () => {
    setOpen(false);
    tabla && tabla(true);
    actualizar && actualizar();
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={() => setOpen(false)} sx={{ color: "#fff" }}>
                <ArrowBackIcon />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Finalizar
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                sx={{ mt: 2 }}
                autoComplete="off"
                label="Detalles (cliente)"
                name="detalles_finalizado"
                size="small"
                focused
                fullWidth
                multiline
                value={datos.detalles_finalizacion ?? ""}
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={8}>
              <TextField
                fullWidth
                focused
                size="small"
                value={
                  datos.fecha_finalizado
                    ? moment(datos.fecha_finalizado).format("DD-MM-YYYY")
                    : moment().format("DD-MM-YYYY")
                }
                placeholder="Fecha de Finalizacion"
                name="fecha_finalizado"
                label="Fecha finalizado"
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>

            <Grid item xs={2}>
              <Button
                variant="outlined"
                color="info"
                size="medium"
                onClick={() => setOpenCloseAdj(true)}
                startIcon={<AttachFileIcon />}
              >
                DOCUMENTACIÓN
              </Button>
            </Grid>
          </Grid>

          <Grid container spacing={1} mt={1}>
            <Grid item xs={12}>
              <Typography textAlign="center" variant="body1" gutterBottom>
                Agregar observaciones
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                value={formDetalles.detalles_finalizado_admin ?? ""}
                onChange={(e) =>
                  setformDetalles((prev) => ({
                    ...prev,
                    detalles_finalizado_admin: e.target.value,
                  }))
                }
                fullWidth
                focused
                size="small"
                type="text"
                placeholder="..."
                name="detalles_finalizado_admin"
                label="Observaciones."
                variant="outlined"
                multiline
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            mt={0}
          >
            <Button
              disabled={disbtn}
              variant="contained"
              type="submit"
              color="success"
              size="small"
              onClick={(e) => handleSubmit(e)}
            >
              Finalizar
            </Button>
          </Grid>
        </DialogActions>

        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={handleClose}
            severity={notificacion.severity}
          />
        ) : null}

        {openCloseAdj ? (
          <UpdatedUploadFiles
            fileId={datos.uuid}
            open={openCloseAdj}
            setOpen={handleCloseAdj}
            title={"Adjuntar archivos"}
          />
        ) : null}
      </Dialog>
    </div>
  );
}
